export const PASSWORD_CHANGE_NOTIFICATION_HEADER_LINK = {
  href: '/dcfront/personal/personalSettingsRegist/',
  text: 'dodaをご利用中の方へ：パスワードの再設定をお願いします。（セキュリティ強化のため、2023年3月14日よりパスワード設定時のルールを変更しています）',
  linkText: '＞パスワードの再設定はこちら',
} as const;
